import { SvgIconProps } from '@mui/material';

export const FeaturedUpgradeIcon = (props: SvgIconProps) => {
  return (
    <svg {...props} fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
      <circle cx="28" cy="28" fill="#F5F5FF" r="28" />
      <circle cx="28" cy="28" fill="#E7E7FC" r="20" />
      <path
        d="M33 34L28 29L23 34M33 27L28 22L23 27"
        stroke="#0B0BCF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
